





































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { UserUpdate } from '@sone/sone-frontend-core/src/models/UserUpdate';
import UserInfo from '@sone/sone-frontend-core/src/models/UserInfo';
import { State, namespace } from 'vuex-class';
import namespaces from '../store/namespaces';
import { UserGetterTypes } from '@sone/sone-frontend-core/src/store/modules/user/getters';
import userService from '@sone/sone-frontend-core/src/services/UserService';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import UserChangeEmailDialog from '@/components/UserChangeEmailDialog.vue';
import UserChangePhoneDialog from '@/components/UserChangePhoneDialog.vue';

const userNamespace = namespace(namespaces.USER);

@Component({
  mixins: [validationMixin],
  validations: {
    form: {
      FirstName: { required },
      LastName: { required },
    },
  },
})
export default class UserProfileCardComponent extends Vue {
  @userNamespace.Getter(UserGetterTypes.INFO)
  public user?: UserInfo;
  public showSnackbar = false;
  public form = new UserUpdate();
  public error?: any = null;
  public loadingFormData = false;
  public formExpand = false;
  public loading = false;
  public initialEmail = '';
  public initialPhoneNumber = '';
  public message: any;

  public async created() {
    if (this.$route && (this.$route.query.error || this.$route.query.updated))
    {
      if(this.$route.query.error && this.$route.query.error === 'invalid_validate') {
        this.message =  this.$t('invalid_code_validation', this.user);
      }else{
        this.message =  this.$t('information_updated_successfully', this.user);
      }
      this.showSnackbar = true;
      setTimeout(() => {
        (window.location as any) = '/';
      }, 5000);
    }
  }

  public async saveChanges() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.loadingFormData = true;
      await userService.updateProfile(this.user!.subject!, this.form);
      this.showSnackbar = true;
      this.loadingFormData = false;
      this.toggleExpand();
    }
  }

  public async toggleExpand() {
    (window as any).$vm = (this as any).$t;
    if (!this.formExpand) {
      this.$v.$reset();
      this.loadingFormData = true;
      const profile = await userService.getUserProfile(this.user!.subject!);
      this.loadingFormData = false;
      this.form = new UserUpdate(profile);
      this.initialEmail = this.form.Email;
      this.initialPhoneNumber = this.form.PhoneNumber;
    }
    this.formExpand = !this.formExpand;
    document.getElementById('expand-button')!.click();
  }
  public toggleDialogPassword() {
    (this.$refs.changePasswordDialog as any).open();
  }

  public toggleDialogEmail() {
    (this.$refs.changeEmailDialog as any).open();
  }

  public toggleDialogPhone() {
    (this.$refs.changePhoneDialog as any).open();
  }
}
